import React from 'react'

const LocationIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path
                d="M8 14.6667C8 14.6667 12 10.6667 12 6.66667C12 4.45753 10.2091 2.66667 8 2.66667C5.79086 2.66667 4 4.45753 4 6.66667C4 10.6667 8 14.6667 8 14.6667Z"
                stroke="#737373"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <circle
                cx="8"
                cy="6.66667"
                r="1.5"
                stroke="#737373"
            />
        </svg>
    )
}

export default LocationIcon